/**
 * Created by razial on 04.09.2025.
 */

const ExtraBar = function () {
    this.icons = [];

    this.onAddIcon = function () {};
    this.onRemoveIcon = function () {};
};

ExtraBar.prototype.addIcon = function (icon) {
    const index = this.icons.indexOf(icon);
    if (index === -1) {
        icon.index = this.icons.length === 0 ? 0 : this.icons[this.icons.length - 1].index + 1;

        this.icons.push(icon);
        if (icon.resetState) {
            icon.resetState();
        }

        this.onAddIcon(icon);
    }
};

ExtraBar.prototype.removeIcon = function (icon, silent) {
    const index = this.icons.indexOf(icon);
    if (index !== -1) {
        this.icons.splice(index, 1);
        this.onRemoveIcon(icon, silent);
    }
};

ExtraBar.prototype.resetIcons = function () {
    this.icons.slice().forEach((icon) => {
        this.removeIcon(icon, true);
    });
};

ExtraBar.prototype.listIcons = function () {
    return this.icons;
};

ExtraBar.prototype.findOfferIcon = function (offer) {
    for (let i = 0; i < this.icons.length; i++) {
        const icon = this.icons[i];
        if ((icon instanceof OfferIcon) && icon.offer === offer) {
            return icon;
        }
    }
    return undefined;
};

ExtraBar.prototype.anyIconWithForce = function () {
    for (let i = 0; i < this.icons.length; i++) {
        const icon = this.icons[i];
        if (icon.resetState) {
            icon.resetState();
        }
        if (icon.available) {
            const force = icon.getForce();
            if (force && !cleverapps.forces.isShown(force)) {
                return icon;
            }
        }
    }

    return undefined;
};

ExtraBar.prototype.showAnyForce = function () {
    cleverapps.focusManager.display({
        focus: "extrabarIconForce",
        control: "extrabar",
        actions: [
            (f) => {
                cleverapps.timeouts.setTimeout(f, 1100);
            },

            (f) => {
                const icon = this.anyIconWithForce();
                if (!icon) {
                    f();
                    return;
                }

                icon.onShowForce();

                cleverapps.forces.onceForceClosed = f;
            }
        ]
    });
};